module.exports = __webpack_public_path__ + "img/forbes-cover-sidebar.d91b8743.jpg";